import { render, staticRenderFns } from "./StationSliderStudents.vue?vue&type=template&id=e5028b96&scoped=true&"
import script from "./StationSliderStudents.vue?vue&type=script&lang=js&"
export * from "./StationSliderStudents.vue?vue&type=script&lang=js&"
import style0 from "./StationSliderStudents.vue?vue&type=style&index=0&id=e5028b96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5028b96",
  null
  
)

export default component.exports